import { SettingsTab } from 'types/app';

export const APP_PATH = process.env['APP_PATH'];
export const API_PATH = process.env['API_PATH'];
export const CDN_PATH = process.env['CDN_PATH'];
export const ENV_NAME = process.env['ENV_NAME'];

export const LANDING_PATH = 'https://easyecheck.online';

export const SCHEDULE_INTERVAL = Number(
  process.env['SCHEDULE_INTERVAL'] || '15',
);

export const appUrl = () => `${APP_PATH}`;
export const notFoundUrl = () => `${appUrl()}404/`;

// anonymous routes
export const userFormUrl = () => `${appUrl()}user/`;
export const loginUrl = () => `${userFormUrl()}login`;
export const registerUrl = () => `${userFormUrl()}register`;
export const forgotPasswordUrl = () => `${userFormUrl()}forgot-password`;
export const authCallbackUrl = () => `${appUrl()}auth/callback`;

// anonymous check routes
export const verifyCheckUrl = () => `${appUrl()}verify/`;
export const verifyCheckWithIdUrl = (code: string) =>
  `${verifyCheckUrl()}${code}`;

export const printECheckUrl = () => `${appUrl()}print-echeck/`;
export const printAnonECheckUrl = (eCheckId: string) =>
  `${printECheckUrl()}${eCheckId}`;

// external info pages — open these with window.open, they are not app routes
export const disclaimerUrl = () => `${LANDING_PATH}/disclaimer`;
export const helpCenterUrl = () => `https://easyecheck.tawk.help/`;
export const privacyPolicyUrl = () => `${LANDING_PATH}/privacy-policy`;
export const termsAndConditionsUrl = () =>
  `${LANDING_PATH}/terms-and-conditions`;

// user routes
export const organizationListUrl = () => `${appUrl()}`;
export const userPayeeListUrl = () => `${appUrl()}payees/`;
export const resetPasswordUrl = () => `${appUrl()}reset-password/`;
export const resetUserPasswordUrl = (email: string, token: string) =>
  `${resetPasswordUrl()}${email}/${token}`;
export const userPaymentListUrl = () => `${appUrl()}payments/`;
export const userPaymentDetailsUrl = (paymentId: string) =>
  `${appUrl()}payment/${paymentId}/`;

// organization routes
export const apiSpecUrl = (organizationId: string) =>
  `${organizationUrl(organizationId)}docs`;
export const organizationUrl = (organizationId: string) =>
  `${organizationListUrl()}${organizationId}/`;
export const paymentListUrl = (organizationId: string) =>
  `${organizationUrl(organizationId)}payment/`;

export const userOrganizationPaymentListUrl = (organizationId: string) =>
  `${organizationUrl(organizationId)}payments/`;

export const organizationDashboardUrl = (organizationId: string) =>
  `${organizationUrl(organizationId)}`;

export const bankListUrl = (organizationId: string) =>
  `${organizationUrl(organizationId)}bank/`;

export const bankCheckListUrl = (organizationId: string, bankId: string) =>
  `${bankListUrl(organizationId)}${bankId}/check`;

export const userPaymentOrganizationDetailsUrl = (
  organizationId: string,
  paymentId: string,
) => `${organizationUrl(organizationId)}payments/${paymentId}/`;

export const payeeListUrl = (organizationId: string) =>
  `${organizationUrl(organizationId)}payee/`;

export const userOrganizationPayeeListUrl = (organizationId: string) =>
  `${organizationUrl(organizationId)}payees/`;

export const memberListUrl = (organizationId: string) =>
  `${organizationUrl(organizationId)}members/`;

export const userActivityListUrl = (organizationId: string) =>
  `${organizationUrl(organizationId)}activity/`;

export const settingsUrl = (organizationId: string) =>
  `${organizationUrl(organizationId)}settings/`;

export const settingsTabUrl = (organizationId: string, tab: SettingsTab) =>
  `${settingsUrl(organizationId)}${tab}`;

export const auditUrl = (organizationId: string) =>
  `${organizationUrl(organizationId)}audit/`;

export const userProfileUrl = (organizationId?: string | undefined) =>
  organizationId
    ? `${organizationUrl(organizationId)}user/profile/`
    : `${appUrl()}user/profile/`;

export const superAdminUrl = () => `${appUrl()}admin/`;
export const superAdminOrganizationUrl = (organizationId: string) =>
  `${superAdminUrl()}organization/${organizationId}/`;
